import { Injectable } from '@angular/core'
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApiService } from '../services/api.service';
import { BehaviorSubject, Observer, Subscription } from 'rxjs';
import { ApiServiceDelegate } from '../models/api-service-delegate';
import { ApiCollection } from '../providers/api-collection';
import { CetSourcingNeedsV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/cet-sourcing-needs-v2.component';
import { SourcingNeedModel } from '../models/sourcing-need.model';
import { StandardModel, StandardResponseModel } from '../models/project.model';
import { SnFormVenueV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-venue-v2/sn-form-venue-v2.component';
import { SnFormCateringV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-catering-v2/sn-form-catering-v2.component';
import { SnFormExperienceV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-experience-v2/sn-form-experience-v2.component';
import { SnFormFurnitureV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-furniture-v2/sn-form-furniture-v2.component';
import { SnFormAvV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-av-v2/sn-form-av-v2.component';
import { SnFormSpeakerTalentV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-speaker-talent-v2/sn-form-speaker-talent-v2.component';
import { SnFormTransportV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-transport-v2/sn-form-transport-v2.component';
import { SnFormGiftV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-gift-v2/sn-form-gift-v2.component';
import { SnFormBrandingV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-branding-v2/sn-form-branding-v2.component';
import { SnFormPhotoVideoV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-photo-video-v2/sn-form-photo-video-v2.component';
import { SnFormProductionFabricationV2Component } from '../components/console-event-tab/cet-sourcing-needs-v2/modals/sn-form-production-fabrication-v2/sn-form-production-fabrication-v2.component';
import { OutsourcingTypeResponseModel } from '../models/outsourcing.model';


@Injectable({
    providedIn: 'root'
})

export class SourcingNeedV2ViewModel {

    parentCetSourcingNeedsV2Component: CetSourcingNeedsV2Component;
    parentSnFormVenueV2Component: SnFormVenueV2Component;
    parentSnFormCateringV2Component: SnFormCateringV2Component;
    parentSnFormExperienceV2Component: SnFormExperienceV2Component;
    parentSnFormFurnitureV2Component: SnFormFurnitureV2Component;
    parentSnFormAvV2Component: SnFormAvV2Component;
    parentSnFormSpeakerTalentV2Component: SnFormSpeakerTalentV2Component;
    parentSnFormTransportV2Component: SnFormTransportV2Component;
    parentSnFormGiftV2Component: SnFormGiftV2Component;
    parentSnFormBrandingV2Component: SnFormBrandingV2Component;
    parentSnFormPhotoVideoV2Component: SnFormPhotoVideoV2Component;
    parentSnFormProductionFabricationV2Component: SnFormProductionFabricationV2Component;


    sourcingNeedModel = new BehaviorSubject<SourcingNeedModel>(new SourcingNeedModel());
    sourcingEventTypeModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    outsourcingTypeResponseModel = new BehaviorSubject<OutsourcingTypeResponseModel>(new OutsourcingTypeResponseModel());

    // venue
    venueOptionsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    roomTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    seatingStylesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    // catering
    cateringResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    mealTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    mealTimingsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    nonAlcoholicBeverageResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    alcoholicBeverageResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    dietaryPreferencesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    experienceTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    experienceCategoryResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    experienceTestingTypeResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    microphonesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    audioEquipmentAudioResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    supportInfraResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    avStaffingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    displayUnitsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    camerasAndRecordingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    stageLightingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    videoEquipmentsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    specialLightingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    lightingControlResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    riggingAndSupportResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    speakerAndAudioResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    speakerTalentOptionsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    airportTransfersResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    localVenueTransfersResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    vehiclesTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    stageAccessoriesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    guestManagementResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    signageBrandingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    demoEngagementResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    mediaAdvertisingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    setupBrandingResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    eventStructuresResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    productionInfrastructureResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    liveStreamingHybridResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    intercomCommunicationResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

    constructor(private apiService: ApiService, private message: NzMessageService) {
    }

    subscribeToBrandingModels(
        observer: Observer<StandardResponseModel>, observer2: Observer<StandardResponseModel>, observer3: Observer<StandardResponseModel>,
        observer4: Observer<StandardResponseModel>, observer5: Observer<StandardResponseModel>, observer6: Observer<StandardResponseModel>,
    ){
        this.stageAccessoriesResponseModel.subscribe(observer);
        this.guestManagementResponseModel.subscribe(observer2);
        this.signageBrandingResponseModel.subscribe(observer3);
        this.demoEngagementResponseModel.subscribe(observer4);
        this.mediaAdvertisingResponseModel.subscribe(observer5);
        this.setupBrandingResponseModel.subscribe(observer6);
    }


    subscribeToTrasportModels(
        observer: Observer<StandardResponseModel>, observer2: Observer<StandardResponseModel>, observer3: Observer<StandardResponseModel>,
    ) {
        this.airportTransfersResponseModel.subscribe(observer);
        this.localVenueTransfersResponseModel.subscribe(observer2);
        this.vehiclesTypesResponseModel.subscribe(observer3);
    }


    subscribeToSpeakerTalentOptions(observer: Observer<StandardResponseModel>) {
        this.speakerTalentOptionsResponseModel.subscribe(observer);
    }

    subscribeToAvRequirements(
        observer: Observer<StandardResponseModel>, observer2: Observer<StandardResponseModel>, observer3: Observer<StandardResponseModel>,
        observer4: Observer<StandardResponseModel>, observer5: Observer<StandardResponseModel>, observer6: Observer<StandardResponseModel>,
        observer7: Observer<StandardResponseModel>, observer8: Observer<StandardResponseModel>, observer9: Observer<StandardResponseModel>,
        observer10: Observer<StandardResponseModel>, observer11: Observer<StandardResponseModel>, observer12: Observer<StandardResponseModel>,
    ) {
        this.microphonesResponseModel.subscribe(observer);
        this.audioEquipmentAudioResponseModel.subscribe(observer2);
        this.supportInfraResponseModel.subscribe(observer3);
        this.avStaffingResponseModel.subscribe(observer4);
        this.displayUnitsResponseModel.subscribe(observer5);
        this.camerasAndRecordingResponseModel.subscribe(observer6);
        this.stageLightingResponseModel.subscribe(observer7);
        this.videoEquipmentsResponseModel.subscribe(observer8);
        this.specialLightingResponseModel.subscribe(observer9);
        this.lightingControlResponseModel.subscribe(observer10);
        this.riggingAndSupportResponseModel.subscribe(observer11);
        this.speakerAndAudioResponseModel.subscribe(observer12);
    }

    subscribeToExperienceTypes(
        observer: Observer<StandardResponseModel>,
        observer2: Observer<StandardResponseModel>,
        observer3: Observer<StandardResponseModel>
    ) {
        this.experienceTypesResponseModel.subscribe(observer);
        this.experienceCategoryResponseModel.subscribe(observer2);
        this.experienceTestingTypeResponseModel.subscribe(observer3);
    }

    subscribeToCateringModels(
        observer: Observer<StandardResponseModel>,
        observer2: Observer<StandardResponseModel>,
        observer3: Observer<StandardResponseModel>,
        observer4: Observer<StandardResponseModel>,
        observer5: Observer<StandardResponseModel>,
        observer6: Observer<StandardResponseModel>
    ) {
        this.cateringResponseModel.subscribe(observer);
        this.mealTypesResponseModel.subscribe(observer2);
        this.mealTimingsResponseModel.subscribe(observer3);
        this.nonAlcoholicBeverageResponseModel.subscribe(observer4);
        this.alcoholicBeverageResponseModel.subscribe(observer5);
        this.dietaryPreferencesResponseModel.subscribe(observer6);
    }

    subscribeToProductionFabricationModels(
        observer: Observer<StandardResponseModel>,
        observer2: Observer<StandardResponseModel>,
        observer3: Observer<StandardResponseModel>,
        observer4: Observer<StandardResponseModel>
    ) {
        this.eventStructuresResponseModel.subscribe(observer);
        this.productionInfrastructureResponseModel.subscribe(observer2);
        this.liveStreamingHybridResponseModel.subscribe(observer3);
        this.intercomCommunicationResponseModel.subscribe(observer4);
    }


    subscribeToVenue(
        observer: Observer<StandardResponseModel>,
        observer2: Observer<StandardResponseModel>,
        observer3: Observer<StandardResponseModel>
    ) {
        this.venueOptionsResponseModel.subscribe(observer);
        this.roomTypesResponseModel.subscribe(observer2);
        this.seatingStylesResponseModel.subscribe(observer3);
    }


    subscribeToSourcingNeed(
        observer: Observer<SourcingNeedModel>,
        observer2: Observer<StandardResponseModel>
    ) {
        this.sourcingNeedModel.subscribe(observer);
        this.sourcingEventTypeModel.subscribe(observer2);
    }


    private formatBackendErrors(errors: any): void {
        let errorMessages = '';
        if (typeof errors === 'object') {
            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    errorMessages += `<strong>${key}:</strong> ${Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]}<br>`;
                }
            }
        } else {
            errorMessages = errors.toString();
        }
        this.message.error(errorMessages, { nzDuration: 1500 });
        // return errorMessages;
    }

    initSourcingNeed(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.SourcingNeed,
            Success: (e: any) => {
                this.sourcingNeedModel.next(e);
                this.parentCetSourcingNeedsV2Component.sourcingNeedInitialized();
                this.message.success("Sourcing need initialized successfully.", { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVenueTypes() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SourcingVenueTypes + "?page=1&page_size=100",
            Success: (e: any) => {
                this.venueOptionsResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getRoomTypes() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SourcingVenueRoomTypes + "?page=1&page_size=100",
            Success: (e: any) => {
                this.roomTypesResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getSeatingStyles() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SourcingVenueSeatingStyle + "?page=1&page_size=100",
            Success: (e: any) => {
                this.seatingStylesResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateSouringVenue(payload: object, edit: boolean) {

        let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.SourcingVenue + '/' + payload['id'] : ApiCollection.SourcingVenue,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_venue_required = true
                if (!edit && payload['sourcing_need'] && payload['created_by']) {
                    const updatePayload = {
                        id: payload['sourcing_need'],
                        modified_by: payload['created_by'],
                        is_venue_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-venue-v2');
                } else {
                    this.parentSnFormVenueV2Component.sourcingVenueAdded();
                }
                this.message.success(`Sourcing venue ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateSouringTrasport(payload, edit: boolean) {
           let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.transportRequirements + '/' + payload['id'] : ApiCollection.transportRequirements,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_transport_required = true
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_transport_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-transport-v2');
                } else {
                    this.parentSnFormTransportV2Component.sourcingTrasportAdded();
                }
                this.message.success(`Sourcing transport ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateSouringCatering(payload, edit: boolean) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.SourcingCateging + '/' + payload['id'] : ApiCollection.SourcingCateging,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_catering_required = true
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_catering_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-catering-v2');
                } else {
                    this.parentSnFormCateringV2Component.sourcingCateringAdded();
                }
                this.message.success(`Sourcing catering ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateAvRequirements(payload, edit: boolean) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.AvRequirements + '/' + payload['id'] : ApiCollection.AvRequirements,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_av_required = true
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_av_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-av-v2');
                } else {
                    this.parentSnFormAvV2Component.AvRequirementsAdded();
                }
                this.message.success(`AV requirements ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateSouringBranding(payload, edit: boolean) {
          let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.BrandingAndCollateral + '/' + payload['id'] : ApiCollection.BrandingAndCollateral,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_branding_collateral_required = true
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_branding_collateral_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-branding-v2');
                } else {
                    this.parentSnFormBrandingV2Component.sourcingBrandingAdded();
                }
                this.message.success(`Branding and Collateral requirements ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateSouringPhotoVideo(payload, edit: boolean) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? "PATCH":"POST",
            Action: edit ? ApiCollection.PhotoVideoRequirements + '/' + payload['id'] : ApiCollection.PhotoVideoRequirements,
            Success: (e: any) => {
                // If creating new (not edit), update sourcing need to set is_photographer_videographer_required = true
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_photographer_videographer_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-photo-video-v2');
                } else {
                    this.parentSnFormPhotoVideoV2Component.sourcingPhotoVideoAdded();
                }
                this.message.success(`Photo and Video requirements ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    addUpdateProductionAndFabrication(payload, edit: boolean) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: edit ? 'PATCH' : 'POST',
            Action: edit ? ApiCollection.ProductionAndFabrication + '/' + payload['id'] : ApiCollection.ProductionAndFabrication,
            Success: (e: any) => {
                if (!edit && payload.sourcing_need && payload.created_by) {
                    const updatePayload = {
                        id: payload.sourcing_need,
                        modified_by: payload.created_by,
                        is_production_fabrication_required: true
                    };
                    this.updateSourcingNeed(updatePayload, 'sn-form-production-fabrication-v2');
                } else {
                    this.parentSnFormProductionFabricationV2Component.productionAndFabricationAdded();
                }
                this.message.success(`Production and Fabrication requirements ${edit ? 'updated' : 'added'} successfully.`, { nzDuration: 1500 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateSourcingNeed(payload: any, caller: string) {
        const normalizedPayload = {
            ...payload,
        };

        const omitRemove = normalizedPayload.omitRemove === true;
        delete normalizedPayload.omitRemove;

        if (!omitRemove && normalizedPayload.remove === undefined) {
            normalizedPayload.remove = false;
        }

        let d: ApiServiceDelegate = {
            Data: normalizedPayload,
            Method: "PATCH",
            Action: ApiCollection.SourcingNeed + '/' + normalizedPayload?.id,
            Success: (e: any) => {
                if (caller === 'cet-sourcing-needs-v2') {
                    this.sourcingNeedModel.next(e);
                    this.parentCetSourcingNeedsV2Component.dataReceived();
                    this.message.success("Sourcing need updated successfully.", { nzDuration: 1500 });
                }

                if (caller === 'sn-form-experience-v2') {
                    this.parentSnFormExperienceV2Component.experienceAdded();
                }

                if (caller === 'sn-form-furniture-v2') {
                    this.parentSnFormFurnitureV2Component.furnitureAdded();
                }

                if (caller === 'sn-form-speaker-talent-v2') {
                    this.parentSnFormSpeakerTalentV2Component.speakerTalentAdded();
                }

                if(caller === 'sn-form-gift-v2'){
                    this.parentSnFormGiftV2Component.sourcingGiftAdded();
                }

                if(caller === 'sn-form-av-v2'){
                    this.parentSnFormAvV2Component.AvRequirementsAdded();
                }

                if(caller === 'sn-form-venue-v2'){
                    this.parentSnFormVenueV2Component.sourcingVenueAdded();
                }

                if(caller === 'sn-form-catering-v2'){
                    this.parentSnFormCateringV2Component.sourcingCateringAdded();
                }

                if(caller === 'sn-form-transport-v2'){
                    this.parentSnFormTransportV2Component.sourcingTrasportAdded();
                }

                if(caller === 'sn-form-branding-v2'){
                    this.parentSnFormBrandingV2Component.sourcingBrandingAdded();
                }

                if(caller === 'sn-form-photo-video-v2'){
                    this.parentSnFormPhotoVideoV2Component.sourcingPhotoVideoAdded();
                }

                if(caller === 'sn-form-production-fabrication-v2'){
                    this.parentSnFormProductionFabricationV2Component.productionAndFabricationAdded();
                }
                return e;
            },
            Error: (e: String) => {

                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getSouringNeedbyId(id: number, caller: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SourcingNeed + '/' + id,
            Success: (e: any) => {
                if (caller === 'cet-sourcing-needs-v2') {
                    this.sourcingNeedModel.next(e);
                    this.parentCetSourcingNeedsV2Component.dataReceived();
                }
                if(caller == 'pdf-generation-component'){
                  this.sourcingNeedModel.next(e);
                }

                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getSouringEventTypes() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SourcingEventType + "?page=1&page_size=100",
            Success: (e: any) => {
                this.sourcingEventTypeModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getExperienceTypes() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.ExperienceTypes + "?page=1&page_size=100",
            Success: (e: any) => {
                this.experienceTypesResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getExperienceCategory(experienceTypeId: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.ExperienceCategory + "?experience_type=" + experienceTypeId,
            Success: (e: any) => {
                this.experienceCategoryResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getExperienceTestingType(experienceCategoryId: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.ExperienceTestingType + "?experience_category=" + experienceCategoryId,
            Success: (e: any) => {
                this.experienceTestingTypeResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createSourcingNeedExperienceSelection(payload: any, caller: string) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.SourcingNeedExperienceSelection,
            Success: (e: any) => {
                if (caller === 'sn-form-experience-v2') {
                    this.parentSnFormExperienceV2Component.experienceAdded();
                }
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateSourcingNeedExperienceSelection(payload: any, id: number, caller: string) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.SourcingNeedExperienceSelection + '/' + id,
            Success: (e: any) => {
                if (caller === 'sn-form-experience-v2') {
                    this.parentSnFormExperienceV2Component.experienceAdded();
                }
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getSpeakerTalentOptions() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.SpeakerOnTalent + "?page=1&page_size=100",
            Success: (e: any) => {
                this.speakerTalentOptionsResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteSorucingObject(id: number, key: string, callback?: () => void) {
        var url = '';
        switch (key) {
            case 'is_venue_required':
                url = ApiCollection.SourcingVenue;
                break;
            case 'is_transport_required':
                url = ApiCollection.transportRequirements;
                break;
            case 'is_catering_required':
                url = ApiCollection.SourcingCateging;
                break;
            case 'is_branding_collateral_required':
                url = ApiCollection.BrandingAndCollateral;
                break;
            case 'is_av_required':
                url = ApiCollection.AvRequirements;
                break;
            case 'is_photographer_videographer_required':
                url = ApiCollection.PhotoVideoRequirements;
                break;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: url + '/' + id,
            Success: (e: any) => {
                this.parentCetSourcingNeedsV2Component.sourcingComponentDeleted(key);
                if (callback) callback();
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    initGeneralCallsForBrandings() {
        this.generalGetCalls('stageAccessories', ApiCollection.StageAccessories, 1, 100);
        this.generalGetCalls('guestManagement', ApiCollection.GuestManagement, 1, 100);
        this.generalGetCalls('signageBranding', ApiCollection.SignageBranding, 1, 100);
        this.generalGetCalls('demoEngagement', ApiCollection.DemoEngagement, 1, 100);
        this.generalGetCalls('mediaAdvertising', ApiCollection.MediaAdvertising, 1, 100);
        this.generalGetCalls('setupBranding', ApiCollection.SetupBranding, 1, 100);
    }

    initGeneralCallsForTransport() {
        this.generalGetCalls('airportTransfers', ApiCollection.AirportTransfers, 1, 100);
        this.generalGetCalls('localVenueTransfers', ApiCollection.LocalVenueTransfers, 1, 100);
        this.generalGetCalls('vehiclesTypes', ApiCollection.VehiclesTypes, 1, 100);
    }

    initGeneralCallsForCatering() {
        this.generalGetCalls('cateringTypes', ApiCollection.CateringTypes, 1, 100);
        this.generalGetCalls('mealTypes', ApiCollection.MealTypes, 1, 100);
        this.generalGetCalls('mealTimings', ApiCollection.MealTiming, 1, 100);
        this.generalGetCalls('nonAlcoholicBeverage', ApiCollection.NonAlcoholicBeverage, 1, 100);
        this.generalGetCalls('alcoholicBeverage', ApiCollection.AlcoholicBeverage, 1, 100);
        this.generalGetCalls('dietaryPreferences', ApiCollection.DietaryPreferences, 1, 100);
    }

    initGeneralCallsForAvRequirements() {
        this.generalGetCalls('microphones', ApiCollection.Microphones, 1, 100);
        this.generalGetCalls('audioEquipmentAudio', ApiCollection.AudioEquipmentAudio, 1, 100);
        this.generalGetCalls('supportInfra', ApiCollection.SupportInfra, 1, 100);
        this.generalGetCalls('AvStaffing', ApiCollection.AvStaffing, 1, 100);
        this.generalGetCalls('displayUnits', ApiCollection.DisplayUnits, 1, 100);
        this.generalGetCalls('camerasAndRecording', ApiCollection.CamerasAndRecording, 1, 100);
        this.generalGetCalls('stageLighting', ApiCollection.StageLighting, 1, 100);
        this.generalGetCalls('videoEquipments', ApiCollection.VideoEquipments, 1, 100);
        this.generalGetCalls('specialLighting', ApiCollection.SpecialLighting, 1, 100);
        this.generalGetCalls('lightingControl', ApiCollection.LightingControl, 1, 100);
        this.generalGetCalls('riggingAndSupport', ApiCollection.RiggingAndSupport, 1, 100);
        this.generalGetCalls('speakerAndAudio', ApiCollection.SpeakerAndAudio, 1, 100);
    }

    initGeneralCallsForProductionFabrication() {
        this.generalGetCalls('eventStructures', ApiCollection.ProductionEventStructure, 1, 100);
        this.generalGetCalls('productionInfrastructure', ApiCollection.ProductionInfrastructure, 1, 100);
        this.generalGetCalls('liveStreamingHybrid', ApiCollection.LiveStreamingHybrid, 1, 100);
        this.generalGetCalls('intercomCommunication', ApiCollection.IntercomCommunication, 1, 100);
    }

    generalGetCalls(type: string, url: string, page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.generalGetCallsSuccessHandler(e, type);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    generalGetCallsSuccessHandler(e: any, type: string) {
        switch (type) {
            case 'microphones':
                this.microphonesResponseModel.next(e);
                break;
            case 'audioEquipmentAudio':
                this.audioEquipmentAudioResponseModel.next(e);
                break;
            case 'supportInfra':
                this.supportInfraResponseModel.next(e);
                break;
            case 'AvStaffing':
                this.avStaffingResponseModel.next(e);
                break;
            case 'displayUnits':
                this.displayUnitsResponseModel.next(e);
                break;
            case 'camerasAndRecording':
                this.camerasAndRecordingResponseModel.next(e);
                break;
            case 'stageLighting':
                this.stageLightingResponseModel.next(e);
                break;
            case 'videoEquipments':
                this.videoEquipmentsResponseModel.next(e);
                break;
            case 'specialLighting':
                this.specialLightingResponseModel.next(e);
                break;
            case 'lightingControl':
                this.lightingControlResponseModel.next(e);
                break;
            case 'riggingAndSupport':
                this.riggingAndSupportResponseModel.next(e);
                break;
            case 'speakerAndAudio':
                this.speakerAndAudioResponseModel.next(e);
                break;
            case 'cateringTypes':
                this.cateringResponseModel.next(e);
                break;
            case 'mealTypes':
                this.mealTypesResponseModel.next(e);
                break;
            case 'mealTimings':
                this.mealTimingsResponseModel.next(e);
                break;
            case 'nonAlcoholicBeverage':
                this.nonAlcoholicBeverageResponseModel.next(e);
                break;
            case 'alcoholicBeverage':
                this.alcoholicBeverageResponseModel.next(e);
                break;
            case 'dietaryPreferences':
                this.dietaryPreferencesResponseModel.next(e);
                break;
            case 'airportTransfers':
                this.airportTransfersResponseModel.next(e);
                break;
            case 'localVenueTransfers':
                this.localVenueTransfersResponseModel.next(e);
                break;
            case 'vehiclesTypes':
                this.vehiclesTypesResponseModel.next(e);
                break;
            case 'stageAccessories':
                this.stageAccessoriesResponseModel.next(e);
                break;
            case 'guestManagement':
                this.guestManagementResponseModel.next(e);
                break;
            case 'signageBranding':
                this.signageBrandingResponseModel.next(e);
                break;
            case 'demoEngagement':
                this.demoEngagementResponseModel.next(e);
                break;
            case 'mediaAdvertising':
                this.mediaAdvertisingResponseModel.next(e);
                break;
            case 'setupBranding':
                this.setupBrandingResponseModel.next(e);
                break;
            case 'eventStructures':
                this.eventStructuresResponseModel.next(e);
                break;
            case 'productionInfrastructure':
                this.productionInfrastructureResponseModel.next(e);
                break;
            case 'liveStreamingHybrid':
                this.liveStreamingHybridResponseModel.next(e);
                break;
            case 'intercomCommunication':
                this.intercomCommunicationResponseModel.next(e);
                break;
            default:
                break;

        }

        }

    getOutSourcingTypes(name: string, page: number, page_size: number) {
        let url = ApiCollection.OutsourcingType + '?page=' + page + '&page_size=' + page_size;
        if (name) {
            url += '&name=' + name;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingTypeResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

}


